const sectionSelector = '.travel-control-section';
const tabSelector = '[data-travel-control-tab]';
const cardSelector = '[data-travel-control-card]';

const activeTabClassName = 'travel-control-section__tab--active';
const activeCardClassName = 'travel-control-section__card--active';

function stopIllustration(card) {
    card.querySelectorAll('.travel-control-section__graphic').forEach((graphic) => {
        graphic.getAnimations({ subtree: true }).forEach((animation) => animation.cancel());
    });
}

function playIllustration(card) {
    stopIllustration(card);
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    const delay = 180;
    card.querySelectorAll('[data-travel-bar-color]').forEach((bar) => {
        bar.animate([{ transform: 'scaleY(0)' }, { transform: 'scaleY(1)' }], {
            duration: 850, delay, easing: 'ease-out', fill: 'backwards',
        });
    });

    const ring = card.querySelector('[data-travel-ring]');
    if (ring) {
        ring.animate([
            { strokeDasharray: '0 100', opacity: 0 },
            { strokeDasharray: '0 100', opacity: 1, offset: 0.01 },
            { strokeDasharray: ring.getAttribute('stroke-dasharray'), opacity: 1 },
        ], { duration: 1150, delay, easing: 'ease-in-out', fill: 'backwards' });
    }

    card.querySelectorAll('[data-travel-cell]').forEach((cell, index) => {
        const frames = cell.hasAttribute('data-travel-cell-alert') ? [
            { fill: 'var(--color-gray-lighter)' },
            { fill: 'var(--color-orange)' },
        ] : [
            { fill: 'var(--color-gray-lighter)' },
            { fill: 'var(--color-accent)', offset: 0.35 },
            { fill: 'var(--color-accent)', offset: 0.65 },
            { fill: 'var(--color-gray-lighter)' },
        ];
        cell.animate(frames, { duration: 180, delay: delay + index * 45, fill: 'backwards' });
    });
}

function setActiveItem(tabs, cards, activeItemName) {
    tabs.forEach((tab) => {
        const isActive = tab.dataset.travelControlTab === activeItemName;

        tab.classList.toggle(activeTabClassName, isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    cards.forEach((card) => {
        const isActive = card.dataset.travelControlCard === activeItemName;

        card.classList.toggle(activeCardClassName, isActive);
        card.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    });
}

export function initTravelControlSection() {
    const sections = document.querySelectorAll(sectionSelector);

    if (!sections.length) {
        return;
    }

    sections.forEach((section) => {
        const tabs = Array.from(section.querySelectorAll(tabSelector));
        const cards = Array.from(section.querySelectorAll(cardSelector));

        if (!tabs.length || !cards.length) {
            return;
        }

        const activeCard = cards.find((card) => card.classList.contains(activeCardClassName)) || cards[0];
        let activeItemName = activeCard.dataset.travelControlCard;

        setActiveItem(tabs, cards, activeItemName);

        let hasStarted = false;
        const viewportTarget = section.querySelector('[data-travel-control-viewport]');
        let viewportObserver;
        const startInitialIllustration = () => {
            if (hasStarted) {
                return;
            }
            hasStarted = true;
            if (viewportObserver) {
                viewportObserver.disconnect();
            }
            playIllustration(cards.find((card) => card.dataset.travelControlCard === activeItemName));
        };
        if (!viewportTarget || viewportTarget.classList.contains('animations-in-viewport--active')) {
            startInitialIllustration();
        } else {
            viewportObserver = new MutationObserver(() => {
                if (viewportTarget.classList.contains('animations-in-viewport--active')) {
                    startInitialIllustration();
                }
            });
            viewportObserver.observe(viewportTarget, { attributes: true, attributeFilter: ['class'] });
        }
        window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', () => {
            cards.forEach(stopIllustration);
        });

        const activateItem = (itemName) => {
            const targetCard = cards.find((card) => card.dataset.travelControlCard === itemName);

            if (!targetCard || itemName === activeItemName) {
                return;
            }

            cards.forEach(stopIllustration);
            hasStarted = true;
            if (viewportObserver) {
                viewportObserver.disconnect();
            }
            activeItemName = itemName;
            setActiveItem(tabs, cards, activeItemName);
            playIllustration(targetCard);
        };

        tabs.forEach((tab) => {
            tab.addEventListener('click', () => {
                activateItem(tab.dataset.travelControlTab);
            });
        });

        cards.forEach((card) => {
            card.addEventListener('click', () => {
                activateItem(card.dataset.travelControlCard);
            });

            card.addEventListener('keydown', (event) => {
                if (event.key !== 'Enter' && event.key !== ' ') {
                    return;
                }

                event.preventDefault();
                activateItem(card.dataset.travelControlCard);
            });
        });
    });
}
